import React from 'react';
import { emitCustomEvent } from 'react-custom-events';

import { usePageStore } from '@client/store/pageStore/context/pageContext';
import i18n from '@client/utils/i18n';
import { Description, LediumForm, SelectZoneTree, TitleAndDescription, UniqueName, type ZoneItem } from '@ledium/ui-common';
import { ZoneWizard } from '@ledium/ui-project-editor';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Button, Container, Grid } from '@mui/material';

interface ZonesViewProps {
    onClose: () => void;
    onSave: () => void;
}

const ZonesView = ({ onClose, onSave }: ZonesViewProps) => {
    const {
        pageState: { formData },
        pageActions
    } = usePageStore();

    const [wizardOpen, setWizardOpen] = React.useState(false);

    const zoneId = typeof formData.id === 'string' ? formData.id : null;

    function onSelect(zoneItem: ZoneItem | undefined) {
        pageActions.formData.updateFormItem({ parent: zoneItem?.id });
    }

    function handleWizardDone(newZoneId: string) {
        if (newZoneId) {
            emitCustomEvent('zonesChanged', { selectZoneId: newZoneId });
        }
    }

    const copyLinkButton = zoneId ? (
        <Button variant="outlined" startIcon={<ContentCopyIcon />} onClick={() => setWizardOpen(true)}>
            {i18n('copy_link_zone')}
        </Button>
    ) : undefined;

    return (
        <Container fixed>
            <LediumForm onSubmit={() => onSave()} onCancel={onClose} header={<TitleAndDescription />} additionalButton={copyLinkButton}>
                <UniqueName />
                <Description />
                <Grid item xs={12}>
                    <SelectZoneTree
                        label={i18n('parent_zone')}
                        denySelectBelow={formData.id as string | undefined}
                        defaultSelected={formData.parent as string | undefined}
                        onSelect={onSelect}
                    />
                </Grid>
            </LediumForm>
            {wizardOpen && zoneId && <ZoneWizard sourceZoneId={zoneId} onClose={() => setWizardOpen(false)} onDone={handleWizardDone} />}
        </Container>
    );
};

export default React.memo(ZonesView);
